// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__TD7CM","content":"Consent_content__3cfMz","footer":"Consent_footer__hk86n"};